const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.58,389.07a158,158,0,0,0,17.81-50.67C496,233.26,459.11,108.72,353.6,64.36c-36.37-15.29-78.12-17.59-115.82-5.8C195,72,167.42,105.34,133,131.89c-24.29,18.72-55,27.86-77.34,49.19C32.07,203.59,17,236,16.89,268.73c-.05,23,9.25,45.43,28,59.5,18.35,13.78,41.7,17.38,61.6,28.16,22.15,12,35.48,33,53.21,50.06,40.91,39.44,102.18,51.65,157.22,49.8C370.93,454.43,431,439.15,459.58,389.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.58,389.07a158,158,0,0,0,17.81-50.67C496,233.26,459.11,108.72,353.6,64.36c-36.37-15.29-78.12-17.59-115.82-5.8C195,72,167.42,105.34,133,131.89c-24.29,18.72-55,27.86-77.34,49.19C32.07,203.59,17,236,16.89,268.73c-.05,23,9.25,45.43,28,59.5,18.35,13.78,41.7,17.38,61.6,28.16,22.15,12,35.48,33,53.21,50.06,40.91,39.44,102.18,51.65,157.22,49.8C370.93,454.43,431,439.15,459.58,389.07Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.22,376c2.72,1.19,9.37,1,9.38,1s-1.43-4.36-1.56-4.62c-1.46-3.05-6.07-8.1-9.83-7.59a4.49,4.49,0,0,0-3.6,5.62C383.23,373.09,385.9,375,388.22,376Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.52,395.3c2.82.42,8.76-1.31,9.23-1.44a80.61,80.61,0,0,0,3.6,10c.82,1.89,1.7,3.77,2.61,5.64l-1.11-1.59c-2.22-2.56-8-6.2-11.49-4.72a4.48,4.48,0,0,0-2,6.37c1.29,2.35,4.37,3.51,6.88,3.87s7.63-1,9-1.37c.36.71.7,1.43,1.06,2.14,1.72,3.43,3.45,6.84,5.05,10.23.56,1.2,1.07,2.4,1.58,3.6-.48-.71-.89-1.3-1-1.38-2.22-2.56-8-6.21-11.49-4.72a4.49,4.49,0,0,0-2,6.37c1.29,2.34,4.38,3.5,6.88,3.87s7.13-.87,8.73-1.31c.49,1.24,1,2.49,1.4,3.71.27.85.59,1.64.81,2.5s.47,1.69.7,2.52c.39,1.62.8,3.29,1.14,4.88.24,1.1.46,2.16.67,3.22-.54-1.19-1.66-3.51-1.78-3.7-1.8-2.86-7-7.34-10.64-6.41a4.49,4.49,0,0,0-2.93,6c.92,2.52,3.8,4.13,6.21,4.87,2.67.81,8.56.07,9.3,0,.35,1.76.68,3.48,1,5.1.63,3.59,1.11,6.8,1.47,9.52h2.48c-.43-2.81-1-6.17-1.74-9.93-.36-1.79-.77-3.69-1.21-5.65a47.09,47.09,0,0,0,5.19-2.44c1.94,2.11,6.91,4.57,7.55,4.88-.68,1.66-1.35,3.27-2,4.78-1.38,3.17-2.68,6-3.83,8.36h2.68c1-2.2,2.08-4.71,3.22-7.48.69-1.69,1.4-3.51,2.11-5.38.71.15,6.55,1.34,9.27.72,2.46-.55,5.45-1.95,6.55-4.39a4.49,4.49,0,0,0-2.47-6.2c-3.59-1.2-9.08,2.88-11.09,5.6-.12.16-1.21,2.05-1.88,3.25.29-.77.57-1.51.86-2.3.57-1.56,1.1-3.14,1.67-4.83l.75-2.51c.27-.83.45-1.75.68-2.63.48-2.05.88-4.15,1.23-6.28,1.37.5,6.26,2.2,8.79,2s5.69-1.1,7.15-3.34a4.49,4.49,0,0,0-1.51-6.51c-3.37-1.74-9.41,1.47-11.81,3.86-.14.14-1.67,2-2.49,3.11.2-1.28.4-2.55.57-3.85.46-3.76.82-7.58,1.19-11.39.11-1.17.24-2.33.36-3.49.49.18,6.26,2.33,9.09,2.13,2.53-.18,5.69-1.1,7.15-3.35a4.48,4.48,0,0,0-1.51-6.5c-3.37-1.74-9.41,1.47-11.81,3.85-.18.18-2.37,2.93-2.9,3.66.27-2.56.57-5.11,1-7.61a78.48,78.48,0,0,1,2.18-10c.23.08,6.24,2.35,9.15,2.15,2.52-.18,5.68-1.11,7.14-3.35a4.48,4.48,0,0,0-1.5-6.5c-3.37-1.74-9.41,1.46-11.81,3.85-.19.19-2.55,3.14-2.94,3.71,0-.19.09-.39.15-.58a57.61,57.61,0,0,1,4-9.48c.86-1.68,1.78-3.25,2.7-4.75,1.08.54,6,2.94,8.66,3.05s5.77-.48,7.47-2.54a4.49,4.49,0,0,0-.78-6.63c-3.16-2.1-9.51.42-12.16,2.53-.15.11-1.48,1.44-2.44,2.42.43-.67.86-1.37,1.29-2,1.58-2.39,3.18-4.48,4.61-6.32.82-1,1.59-2,2.31-2.82,1.33,0,6.7-.19,9-1.29s4.91-3.08,5.46-5.69a4.5,4.5,0,0,0-3.75-5.53c-3.77-.4-8.25,4.76-9.62,7.86-.12.26-1.5,4.66-1.43,4.66h.08c-.72.81-1.47,1.69-2.28,2.67-1.47,1.81-3.12,3.87-4.77,6.23a79.88,79.88,0,0,0-4.94,7.87,58.08,58.08,0,0,0-4.22,9.51.56.56,0,0,1,0,.12c0-1.11,0-4.22-.06-4.46-.43-3.35-3.24-9.58-7-10.27a4.49,4.49,0,0,0-5.18,4.22c-.21,2.66,1.72,5.33,3.6,7,2.13,1.9,8,3.74,8.5,3.88a79.83,79.83,0,0,0-2.49,10.3c-.36,2-.66,4.08-.94,6.14,0-1,0-1.82-.05-1.94-.43-3.35-3.25-9.58-7-10.27a4.48,4.48,0,0,0-5.17,4.22c-.22,2.66,1.72,5.33,3.6,7s6.92,3.38,8.24,3.8c-.09.79-.2,1.58-.29,2.38-.46,3.8-.9,7.6-1.44,11.31-.19,1.31-.42,2.59-.66,3.87,0-.85,0-1.57,0-1.68-.44-3.35-3.25-9.58-7-10.27a4.48,4.48,0,0,0-5.17,4.22c-.22,2.66,1.71,5.33,3.6,7s6.43,3.21,8,3.72c-.27,1.31-.55,2.62-.87,3.87-.25.85-.42,1.69-.71,2.53s-.54,1.67-.81,2.49c-.57,1.57-1.14,3.19-1.74,4.7-.4,1.05-.81,2.05-1.21,3.06.2-1.3.55-3.86.55-4.07a17.33,17.33,0,0,0-2.33-8.48,5.49,5.49,0,0,0-.06-1,4.49,4.49,0,0,0-5.49-3.8c-3.66,1-6,7.4-6.16,10.78,0,.2.12,2.38.23,3.75-.19-.8-.36-1.57-.56-2.39-.38-1.62-.81-3.23-1.27-5-.25-.82-.5-1.66-.76-2.5s-.59-1.7-.88-2.56c-.73-2-1.56-4-2.44-5.93,1.42-.34,6.44-1.61,8.45-3.16s4.13-4.06,4.11-6.73a4.48,4.48,0,0,0-4.84-4.6c-3.77.41-7,6.42-7.72,9.73,0,.21-.27,2.64-.37,4-.54-1.18-1.07-2.36-1.65-3.53-1.68-3.39-3.49-6.78-5.29-10.16-.55-1-1.08-2.07-1.62-3.11.51-.11,6.5-1.5,8.76-3.24,2-1.53,4.13-4.05,4.11-6.73a4.48,4.48,0,0,0-4.84-4.59c-3.77.41-7,6.41-7.72,9.73-.06.25-.37,3.75-.41,4.64-1.19-2.28-2.35-4.57-3.4-6.87a79.33,79.33,0,0,1-3.7-9.56c.24-.05,6.5-1.47,8.81-3.25,2-1.54,4.14-4.05,4.12-6.73a4.48,4.48,0,0,0-4.85-4.59c-3.77.41-7,6.41-7.72,9.72-.06.27-.39,4-.41,4.72,0-.19-.14-.38-.19-.57A58,58,0,0,1,398.48,383c-.21-1.88-.31-3.69-.36-5.45,1.19-.15,6.64-.88,8.9-2.24s4.55-3.58,4.83-6.24a4.48,4.48,0,0,0-4.31-5.1c-3.79,0-7.7,5.6-8.75,8.82-.06.18-.44,2-.69,3.37,0-.8,0-1.62,0-2.39,0-2.86.19-5.49.37-7.81.11-1.32.24-2.51.37-3.62,1.1-.76,5.48-3.85,6.83-6.07S408,351,407,348.54a4.49,4.49,0,0,0-6.18-2.54c-3.37,1.74-4.25,8.52-3.69,11.86,0,.29,1.32,4.72,1.37,4.68l.07-.05c-.15,1.07-.29,2.22-.43,3.48-.23,2.32-.47,4.95-.54,7.83a80,80,0,0,0,.23,9.29,58.48,58.48,0,0,0,1.72,10.26.56.56,0,0,0,0,.12c-.6-.94-2.36-3.5-2.51-3.69-2.22-2.55-8-6.2-11.49-4.72a4.5,4.5,0,0,0-2,6.38C384.93,393.78,388,394.94,390.52,395.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.52,377.5c.06,0,1.21-4.43,1.25-4.72.47-3.35-.6-10.1-4-11.75a4.49,4.49,0,0,0-6.11,2.7c-.91,2.52.25,5.6,1.62,7.73C449.88,374,455.52,377.49,455.52,377.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.43,376c2.72,1.19,9.38,1,9.38,1s-1.43-4.36-1.55-4.62c-1.46-3.05-6.08-8.1-9.84-7.59a4.49,4.49,0,0,0-3.6,5.62C23.45,373.09,26.12,375,28.43,376Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.73,395.3c2.82.42,8.76-1.31,9.23-1.44a80.61,80.61,0,0,0,3.6,10c.82,1.89,1.7,3.77,2.61,5.64-.54-.79-1-1.49-1.11-1.59-2.22-2.56-8-6.2-11.49-4.72a4.49,4.49,0,0,0-2,6.37c1.29,2.35,4.38,3.51,6.88,3.87s7.63-1,9-1.37c.36.71.7,1.43,1.06,2.14,1.72,3.43,3.45,6.84,5,10.23.56,1.2,1.07,2.4,1.59,3.6-.49-.71-.9-1.3-1-1.38-2.21-2.56-8-6.21-11.49-4.72a4.49,4.49,0,0,0-2,6.37c1.29,2.34,4.38,3.5,6.88,3.87s7.14-.87,8.73-1.31c.49,1.24,1,2.49,1.41,3.71.26.85.58,1.64.8,2.5s.47,1.69.7,2.52c.39,1.62.8,3.29,1.14,4.88.25,1.1.46,2.16.68,3.22-.55-1.19-1.67-3.51-1.78-3.7-1.81-2.86-7-7.34-10.64-6.41a4.49,4.49,0,0,0-2.93,6c.91,2.52,3.79,4.13,6.21,4.87,2.66.81,8.55.07,9.29,0,.35,1.76.68,3.48,1,5.1.63,3.59,1.11,6.8,1.47,9.52h2.49c-.44-2.81-1-6.17-1.75-9.93-.35-1.79-.76-3.69-1.21-5.65A46.22,46.22,0,0,0,68.32,445c1.94,2.11,6.91,4.57,7.55,4.88-.67,1.66-1.35,3.27-2,4.78-1.37,3.17-2.68,6-3.83,8.36h2.69c1-2.2,2.08-4.71,3.21-7.48.7-1.69,1.4-3.51,2.11-5.38.72.15,6.55,1.34,9.27.72,2.46-.55,5.45-1.95,6.56-4.39a4.49,4.49,0,0,0-2.48-6.2c-3.59-1.2-9.08,2.88-11.09,5.6-.12.16-1.21,2.05-1.88,3.25.29-.77.58-1.51.86-2.3.57-1.56,1.1-3.14,1.67-4.83l.75-2.51c.27-.83.45-1.75.68-2.63.49-2.05.88-4.15,1.23-6.28,1.37.5,6.26,2.2,8.8,2s5.68-1.1,7.14-3.34a4.5,4.5,0,0,0-1.5-6.51c-3.37-1.74-9.41,1.47-11.81,3.86-.15.14-1.68,2-2.5,3.11.2-1.28.41-2.55.57-3.85.47-3.76.82-7.58,1.19-11.39.11-1.17.24-2.33.36-3.49.49.18,6.26,2.33,9.1,2.13,2.52-.18,5.68-1.1,7.14-3.35a4.48,4.48,0,0,0-1.51-6.5c-3.36-1.74-9.4,1.47-11.8,3.85-.18.18-2.38,2.93-2.9,3.66.27-2.56.56-5.11,1-7.61a78.49,78.49,0,0,1,2.19-10c.22.08,6.23,2.35,9.14,2.15,2.52-.18,5.69-1.11,7.15-3.35a4.48,4.48,0,0,0-1.51-6.5c-3.37-1.74-9.41,1.46-11.81,3.85-.19.19-2.55,3.14-2.94,3.71.06-.19.09-.39.15-.58a57.61,57.61,0,0,1,4-9.48c.86-1.68,1.78-3.25,2.71-4.75,1.07.54,6,2.94,8.65,3.05s5.78-.48,7.47-2.54a4.48,4.48,0,0,0-.78-6.63c-3.16-2.1-9.51.42-12.16,2.53-.14.11-1.48,1.44-2.43,2.42.42-.67.85-1.37,1.28-2,1.58-2.39,3.18-4.48,4.61-6.32.83-1,1.59-2,2.31-2.82,1.34,0,6.7-.19,9-1.29s4.91-3.08,5.46-5.69a4.48,4.48,0,0,0-3.75-5.53c-3.77-.4-8.24,4.76-9.62,7.86-.12.26-1.5,4.66-1.43,4.66h.08c-.72.81-1.47,1.69-2.28,2.67-1.47,1.81-3.12,3.87-4.76,6.23a79.89,79.89,0,0,0-5,7.87,59.83,59.83,0,0,0-4.22,9.51l0,.12c0-1.11,0-4.22-.06-4.46-.44-3.35-3.25-9.58-7-10.27a4.48,4.48,0,0,0-5.17,4.22c-.22,2.66,1.71,5.33,3.6,7,2.12,1.9,8,3.74,8.5,3.88a78.23,78.23,0,0,0-2.5,10.3c-.36,2-.66,4.08-.94,6.14,0-1,0-1.82,0-1.94-.43-3.35-3.25-9.58-7-10.27a4.49,4.49,0,0,0-5.18,4.22c-.22,2.66,1.72,5.33,3.6,7s6.92,3.38,8.25,3.8c-.1.79-.21,1.58-.3,2.38-.46,3.8-.89,7.6-1.44,11.31-.19,1.31-.42,2.59-.65,3.87,0-.85,0-1.57,0-1.68-.44-3.35-3.25-9.58-7-10.27a4.48,4.48,0,0,0-5.17,4.22c-.22,2.66,1.72,5.33,3.6,7s6.43,3.21,8,3.72c-.28,1.31-.56,2.62-.88,3.87-.24.85-.42,1.69-.71,2.53s-.54,1.67-.8,2.49c-.57,1.57-1.15,3.19-1.75,4.7-.4,1.05-.81,2.05-1.21,3.06.2-1.3.55-3.86.56-4.07a17.46,17.46,0,0,0-2.34-8.48,5.49,5.49,0,0,0-.06-1,4.49,4.49,0,0,0-5.49-3.8c-3.66,1-6,7.4-6.16,10.78,0,.2.12,2.38.23,3.75-.19-.8-.36-1.57-.56-2.39-.38-1.62-.81-3.23-1.27-5-.25-.82-.5-1.66-.76-2.5s-.59-1.7-.88-2.56c-.73-2-1.56-4-2.44-5.93,1.42-.34,6.44-1.61,8.45-3.16s4.14-4.06,4.12-6.73a4.5,4.5,0,0,0-4.85-4.6c-3.77.41-7,6.42-7.72,9.73,0,.21-.27,2.64-.36,4-.54-1.18-1.07-2.36-1.66-3.53-1.68-3.39-3.49-6.78-5.28-10.16-.55-1-1.09-2.07-1.63-3.11.51-.11,6.51-1.5,8.76-3.24,2-1.53,4.14-4.05,4.12-6.73a4.48,4.48,0,0,0-4.85-4.59c-3.77.41-7,6.41-7.72,9.73,0,.25-.37,3.75-.41,4.64-1.18-2.28-2.34-4.57-3.4-6.87a79.33,79.33,0,0,1-3.7-9.56c.24-.05,6.5-1.47,8.81-3.25,2-1.54,4.14-4.05,4.12-6.73a4.48,4.48,0,0,0-4.85-4.59c-3.77.41-7,6.41-7.72,9.72-.05.27-.39,4-.4,4.72-.06-.19-.14-.38-.2-.57A58,58,0,0,1,38.69,383c-.21-1.88-.31-3.69-.36-5.45,1.19-.15,6.64-.88,8.9-2.24s4.55-3.58,4.83-6.24a4.48,4.48,0,0,0-4.31-5.1c-3.79,0-7.7,5.6-8.75,8.82,0,.18-.43,2-.69,3.37,0-.8,0-1.62,0-2.39,0-2.86.19-5.49.37-7.81.11-1.32.24-2.51.37-3.62,1.1-.76,5.48-3.85,6.83-6.07s2.39-5.27,1.41-7.76A4.49,4.49,0,0,0,41.07,346c-3.36,1.74-4.25,8.52-3.69,11.86,0,.29,1.32,4.72,1.38,4.68l.06-.05c-.15,1.07-.29,2.22-.43,3.48-.23,2.32-.47,4.95-.53,7.83a77.78,77.78,0,0,0,.22,9.29,58.48,58.48,0,0,0,1.72,10.26l0,.12c-.6-.94-2.35-3.5-2.51-3.69-2.22-2.55-8-6.2-11.49-4.72a4.5,4.5,0,0,0-2,6.38C25.14,393.78,28.23,394.94,30.73,395.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.73,377.5c.06,0,1.21-4.43,1.25-4.72.47-3.35-.6-10.1-4-11.75a4.49,4.49,0,0,0-6.11,2.7c-.91,2.52.25,5.6,1.62,7.73C90.1,374,95.73,377.49,95.73,377.5Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 459,
    y1: 463,
    x2: 473,
    y2: 463,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199,
    y1: 463,
    x2: 445,
    y2: 463,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 463,
    x2: 189,
    y2: 463,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.12,84.43c0,7.87-14.27,24.33-14.27,24.33S98.59,92.3,98.59,84.43a14.27,14.27,0,0,1,28.53,0ZM263.85,356.22a14.25,14.25,0,0,0-14.26,14.26c0,7.87,14.26,24.33,14.26,24.33s14.26-16.46,14.26-24.33A14.26,14.26,0,0,0,263.85,356.22ZM383,29.9a14.26,14.26,0,0,0-14.26,14.26C368.71,52,383,68.49,383,68.49S397.23,52,397.23,44.16A14.27,14.27,0,0,0,383,29.9ZM65.88,217.81a14.25,14.25,0,0,0-14.26,14.26c0,7.87,14.26,24.32,14.26,24.32s14.26-16.45,14.26-24.32A14.26,14.26,0,0,0,65.88,217.81Zm379.16-5A14.27,14.27,0,0,0,430.78,227c0,7.88,14.26,24.33,14.26,24.33S459.3,234.91,459.3,227A14.26,14.26,0,0,0,445,212.77ZM383,50.2h-6a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2ZM321.73,375.51a1,1,0,0,0-1-1h-12a1,1,0,0,0,0,2h12A1,1,0,0,0,321.73,375.51Zm-23.9,0a1,1,0,0,0-1-1H284.89a1,1,0,0,0,0,2h11.94A1,1,0,0,0,297.83,375.51Zm34.94.91a16.9,16.9,0,0,0,11-5.75,1,1,0,0,0-.1-1.41,1,1,0,0,0-1.41.1,14.92,14.92,0,0,1-9.69,5.07,1,1,0,0,0,.11,2ZM274,374.8a1,1,0,0,0-.52-1.32,12.82,12.82,0,0,1-7.21-8,1,1,0,0,0-1.26-.65,1,1,0,0,0-.65,1.25,14.82,14.82,0,0,0,8.33,9.2.91.91,0,0,0,.39.08A1,1,0,0,0,274,374.8ZM347.9,359V347.07a1,1,0,0,0-2,0V359a1,1,0,0,0,2,0Zm-82.21-5.07v-8.21a26.22,26.22,0,0,0-.29-3.87,1,1,0,0,0-1.14-.84,1,1,0,0,0-.84,1.14,23.54,23.54,0,0,1,.27,3.57v8.21a1,1,0,0,0,2,0Zm82.21-18.82V323.17a1,1,0,1,0-2,0v11.95a1,1,0,0,0,2,0Zm-87.42-3.23a1,1,0,0,0,.21-1.4,25.93,25.93,0,0,0-9.44-7.89,1,1,0,1,0-.88,1.79,23.9,23.9,0,0,1,8.71,7.29,1,1,0,0,0,1.4.21ZM240.25,321a1,1,0,0,0-1-1H227.31a1,1,0,1,0,0,2h11.94A1,1,0,0,0,240.25,321Zm-23.89,0a1,1,0,0,0-1-1h-12a1,1,0,1,0,0,2h12A1,1,0,0,0,216.36,321Zm-23.89,0a1,1,0,0,0-1-1H179.52a1,1,0,1,0,0,2h11.95A1,1,0,0,0,192.47,321Zm-23.89,0a1,1,0,0,0-1-1h-12a1,1,0,0,0,0,2h12A1,1,0,0,0,168.58,321Zm-23.9,0a1,1,0,0,0-1-1H131.74a1,1,0,0,0,0,2h11.94A1,1,0,0,0,144.68,321Zm-23.89,0a1,1,0,0,0-1-1H107.85a1,1,0,0,0,0,2h11.94A1,1,0,0,0,120.79,321ZM96.9,321a1,1,0,0,0-1-1H84a1,1,0,1,0,0,2h12A1,1,0,0,0,96.9,321Zm-23.68-1.6a1,1,0,0,0-.44-1.34,18.5,18.5,0,0,1-8-7.79,1,1,0,0,0-1.77.93,20.51,20.51,0,0,0,8.84,8.65,1,1,0,0,0,.45.1A1,1,0,0,0,73.22,319.39ZM62.68,299.15V287.2a1,1,0,0,0-2,0v11.95a1,1,0,0,0,2,0Zm0-23.89V263.31a1,1,0,0,0-2,0v11.95a1,1,0,0,0,2,0Zm0-23.9v-5a10.67,10.67,0,0,1,1.81-6,1,1,0,1,0-1.67-1.11,12.67,12.67,0,0,0-2.14,7.07v5a1,1,0,0,0,2,0Zm405.6-16.61a1,1,0,0,0,.63-1.27,1,1,0,0,0-1.26-.63,14.43,14.43,0,0,1-4.57.73h-7a1,1,0,0,0,0,2h7A16.69,16.69,0,0,0,468.28,234.75Zm-23.13-.17a1,1,0,0,0-1-1H432.21a1,1,0,0,0,0,2h11.94A1,1,0,0,0,445.15,234.58Zm-23.89,0a1,1,0,0,0-1-1H408.32a1,1,0,0,0,0,2h11.94A1,1,0,0,0,421.26,234.58Zm-23.89,0a1,1,0,0,0-1-1H384.42a1,1,0,0,0,0,2h11.95A1,1,0,0,0,397.37,234.58Zm-23.89,0a1,1,0,0,0-1-1h-12a1,1,0,0,0,0,2h12A1,1,0,0,0,373.48,234.58Zm-23.89,0a1,1,0,0,0-1-1H336.64a1,1,0,0,0,0,2h11.95A1,1,0,0,0,349.59,234.58Zm-23.9,0a1,1,0,0,0-1-1H312.75a1,1,0,0,0,0,2h11.94A1,1,0,0,0,325.69,234.58Zm-23.89,0a1,1,0,0,0-1-1H288.86a1,1,0,0,0,0,2H300.8A1,1,0,0,0,301.8,234.58Zm-23.89,0a1,1,0,0,0-1-1H265a1,1,0,0,0,0,2h12A1,1,0,0,0,277.91,234.58Zm-23.89,0a1,1,0,0,0-1-1h-12a1,1,0,0,0,0,2h12A1,1,0,0,0,254,234.58Zm-23.89,0a1,1,0,0,0-1-1H217.18a1,1,0,0,0,0,2h11.95A1,1,0,0,0,230.13,234.58Zm-23.9,0a1,1,0,0,0-1-1H193.29a1,1,0,0,0,0,2h11.94A1,1,0,0,0,206.23,234.58Zm-23.89,0a1,1,0,0,0-1-1H169.4a1,1,0,0,0,0,2h11.94A1,1,0,0,0,182.34,234.58Zm-23.89,0a1,1,0,0,0-1-1H145.5a1,1,0,0,0,0,2h11.95A1,1,0,0,0,158.45,234.58Zm-23.89,0a1,1,0,0,0-1-1h-12a1,1,0,1,0,0,2h12A1,1,0,0,0,134.56,234.58Zm-23.89,0a1,1,0,0,0-1-1h-12a1,1,0,0,0,0,2h12A1,1,0,0,0,110.67,234.58Zm-23.9,0a1,1,0,0,0-1-1H73.83a1,1,0,0,0,0,2H85.77A1,1,0,0,0,86.77,234.58Zm391-7.87a16.49,16.49,0,0,0,1.88-7.65v-4.47a1,1,0,0,0-2,0v4.47a14.49,14.49,0,0,1-1.65,6.72,1,1,0,1,0,1.77.93Zm1.88-24.07V190.7a1,1,0,1,0-2,0v11.94a1,1,0,0,0,2,0Zm0-23.89v-4.14a16.57,16.57,0,0,0-2-8,1,1,0,0,0-1.36-.39,1,1,0,0,0-.39,1.35,14.58,14.58,0,0,1,1.79,7v4.14a1,1,0,0,0,2,0Zm-11-18.69a1,1,0,0,0-.66-1.25,16.58,16.58,0,0,0-4.86-.72h-7.31a1,1,0,0,0,0,2h7.31a14.3,14.3,0,0,1,4.27.64,1,1,0,0,0,.3,0A1,1,0,0,0,468.6,160.06Zm-23.77-1a1,1,0,0,0-1-1H431.88a1,1,0,0,0,0,2h11.95A1,1,0,0,0,444.83,159.09Zm-23.9,0a1,1,0,0,0-1-1H408a1,1,0,0,0,0,2h11.94A1,1,0,0,0,420.93,159.09Zm-23.89,0a1,1,0,0,0-1-1H384.1a1,1,0,0,0,0,2H396A1,1,0,0,0,397,159.09Zm-23.89,0a1,1,0,0,0-1-1H360.2a1,1,0,0,0,0,2h11.95A1,1,0,0,0,373.15,159.09Zm-23.89,0a1,1,0,0,0-1-1H336.31a1,1,0,0,0,0,2h11.95A1,1,0,0,0,349.26,159.09Zm-23.89,0a1,1,0,0,0-1-1H312.42a1,1,0,0,0,0,2h11.95A1,1,0,0,0,325.37,159.09Zm-23.9,0a1,1,0,0,0-1-1H288.53a1,1,0,0,0,0,2h11.94A1,1,0,0,0,301.47,159.09Zm-23.89,0a1,1,0,0,0-1-1H264.64a1,1,0,0,0,0,2h11.94A1,1,0,0,0,277.58,159.09Zm-23.89,0a1,1,0,0,0-1-1H240.74a1,1,0,0,0,0,2h11.95A1,1,0,0,0,253.69,159.09Zm-23.89,0a1,1,0,0,0-1-1h-12a1,1,0,0,0,0,2h12A1,1,0,0,0,229.8,159.09Zm-23.89,0a1,1,0,0,0-1-1H193a1,1,0,0,0,0,2h11.95A1,1,0,0,0,205.91,159.09Zm-23.9,0a1,1,0,0,0-1-1H169.07a1,1,0,0,0,0,2H181A1,1,0,0,0,182,159.09Zm-23.89,0a1,1,0,0,0-1-1H145.18a1,1,0,0,0,0,2h11.94A1,1,0,0,0,158.12,159.09Zm-23.89,0a1,1,0,0,0-1-1H121.28a1,1,0,0,0,0,2h11.95A1,1,0,0,0,134.23,159.09Zm-23.2-3a1,1,0,0,0,0-1.42,12.31,12.31,0,0,1-3.85-9v-1.08a1,1,0,0,0-2,0v1.08a14.3,14.3,0,0,0,4.47,10.44,1,1,0,0,0,.69.28A1,1,0,0,0,111,156.07Zm-3.89-23.43V120.69a1,1,0,0,0-2,0v11.95a1,1,0,0,0,2,0Zm0-23.9v-2.5a14.89,14.89,0,0,1,2.54-8.34A1,1,0,1,0,108,96.78a16.84,16.84,0,0,0-2.89,9.46v2.5a1,1,0,0,0,2,0Zm11.54-17a14.9,14.9,0,0,1,3.4-.39h8.29a1,1,0,0,0,0-2h-8.29a17.16,17.16,0,0,0-3.85.44,1,1,0,0,0-.75,1.2,1,1,0,0,0,1,.77A.86.86,0,0,0,118.68,91.69Zm23.79-.63a16.16,16.16,0,0,0,10.45-6.68,1,1,0,0,0-.25-1.39,1,1,0,0,0-1.39.25,14.19,14.19,0,0,1-9.15,5.85,1,1,0,0,0,.17,2ZM155.8,72.42V64.3a14.48,14.48,0,0,1,.44-3.54,1,1,0,1,0-1.93-.49,16,16,0,0,0-.51,4v8.12a1,1,0,1,0,2,0Zm7-20.31a14.06,14.06,0,0,1,7.09-1.91h4a1,1,0,0,0,0-2h-4a16.07,16.07,0,0,0-8.1,2.18,1,1,0,0,0-.36,1.37,1,1,0,0,0,1.37.36ZM366,49.2a1,1,0,0,0-1-1H353.07a1,1,0,0,0,0,2H365A1,1,0,0,0,366,49.2Zm-23.89,0a1,1,0,0,0-1-1H329.18a1,1,0,0,0,0,2h11.95A1,1,0,0,0,342.13,49.2Zm-23.89,0a1,1,0,0,0-1-1H305.29a1,1,0,0,0,0,2h11.95A1,1,0,0,0,318.24,49.2Zm-23.9,0a1,1,0,0,0-1-1H281.4a1,1,0,0,0,0,2h11.94A1,1,0,0,0,294.34,49.2Zm-23.89,0a1,1,0,0,0-1-1H257.51a1,1,0,0,0,0,2h11.94A1,1,0,0,0,270.45,49.2Zm-23.89,0a1,1,0,0,0-1-1H233.61a1,1,0,0,0,0,2h11.95A1,1,0,0,0,246.56,49.2Zm-23.89,0a1,1,0,0,0-1-1H209.72a1,1,0,0,0,0,2h11.95A1,1,0,0,0,222.67,49.2Zm-23.89,0a1,1,0,0,0-1-1H185.83a1,1,0,0,0,0,2h11.95A1,1,0,0,0,198.78,49.2ZM347.9,311.05v-6a1,1,0,0,0-2,0v6a1,1,0,1,0,2,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.38,156.7v-5.12h-3.3v5.12H75.82v-5.12h-3.3v5.12H64.26v-5.12H61v5.12H57.39v31H90.94v-31ZM68,180.66H62.71v-5.29H68Zm0-8.37H62.71V167H68Zm8.81,8.37H71.52v-5.29h5.29Zm0-8.37H71.52V167h5.29Zm8.81,8.37H80.33v-5.29h5.29Zm0-8.37H80.33V167h5.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.38,409.7v-5.12h-3.3v5.12h-8.26v-5.12h-3.3v5.12h-8.26v-5.12H255v5.12h-3.56v31h33.55v-31Zm-19.38,24h-5.29v-5.29H262Zm0-8.37h-5.29V420H262Zm8.81,8.37h-5.29v-5.29h5.29Zm0-8.37h-5.29V420h5.29Zm8.81,8.37h-5.29v-5.29h5.29Zm0-8.37h-5.29V420h5.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.57,37.41V32.3h-3.3v5.11H426V32.3H422.7v5.11h-8.25V32.3h-3.31v5.11h-3.56v31h33.55v-31Zm-19.38,24H412.9V56.08h5.29Zm0-8.37H412.9V47.71h5.29ZM427,61.37h-5.29V56.08H427ZM427,53h-5.29V47.71H427Zm8.81,8.37h-5.29V56.08h5.29Zm0-8.37h-5.29V47.71h5.29Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.9,78h260A4.09,4.09,0,0,1,445,82.09V340.63a0,0,0,0,1,0,0H176.81a0,0,0,0,1,0,0V82.09A4.09,4.09,0,0,1,180.9,78Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.76,165.78a6.95,6.95,0,1,1-6.94-6.94A6.95,6.95,0,0,1,222.76,165.78Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,107.32l-34.71,33.33a78.47,78.47,0,0,0-15.27.2,1.7,1.7,0,0,1-1.27-.47c-6.5-5.1-12.56-42.25-15.19-62.38h-1.9c2.09,16,8.2,57.81,15.92,63.87a3.58,3.58,0,0,0,2.68.86,72.22,72.22,0,0,1,13.22-.34l-28.09,27-39.52-29.28a10.06,10.06,0,0,0-13.27,1.14c-4.25,4.45-7.47,8.05-9.59,10.7-2.8,3.49-7.22,9-12.15,15l-14.69-11.83h0c8.72-11.5,16.26-21.44,20.71-26.56,9.05-10.41,30-36.67,41-50.52h-2.42c-11.19,14.1-31.22,39.18-40,49.28-4.49,5.16-12,15.11-20.76,26.63l-20-16.11a.92.92,0,0,0-1.42-1.14l-19.64-15.81a.95.95,0,1,0-1.19,1.47l19.64,15.81c-2.81,3.61-10.7,13.79-16.33,21.39l-52.64-40.58a.95.95,0,0,0-1.16,1.5l52.68,40.61c-1.16,1.58-2.19,3-3,4.19-6.24,9-14.59,17.59-29.24,12.9-15-4.8-17-15.83-17-16.29a1,1,0,0,0-.32-.58L186.4,149.56c1-7.3,2.17-17.55,3.45-32,1.36-15.29,2.43-30.56,3-39.57H191c-1.51,23-3.86,51.79-6.29,70.11L177.54,142v2.5l6.86,5.9c-1.25,9-2.52,15-3.69,15.83a22.07,22.07,0,0,0-3.17,1.8v2.3a23.59,23.59,0,0,1,3.94-2.37c.81-.36,2.36-1,4.6-16.12l12.46,10.71c.45,2.11,3.44,12.7,18.25,17.44a27.48,27.48,0,0,0,8.43,1.41c10.91,0,17.9-7.74,22.94-15,.8-1.16,1.82-2.56,3-4.11l20.26,15.62c-10.87,14-21.57,27-29.05,34-8.92,8.3-20.17,18-29.33,25.78-12.83-8.42-24.86-17.52-25-17.64l-.06,0-.06-.05-10.32-5.6v2.15l7.31,4c-1.75.44-4.35,1.07-7.31,1.68V224c4.59-.94,8.37-1.93,9.67-2.28,2.11,1.59,12.81,9.58,24.28,17.12-8.65,7.31-15.08,12.57-15.21,12.68a1,1,0,0,0-.14,1.34,1,1,0,0,0,1.34.13c.13-.11,6.78-5.56,15.66-13.06,2.64,1.71,5.29,3.38,7.87,4.93l6,3.53c5.16,3.05,11.44,6.77,17.65,10.68l-18.12,19.69a1,1,0,0,0-.19,1,1,1,0,0,0,.81.6c.17,0,16.76,1.45,30.24,20.44,11.73,16.52,22.86,30.41,42.51,39.82h4.6c-21.67-9.23-33.28-23.61-45.57-40.92-11.47-16.17-24.93-20.06-29.79-21l17.14-18.61c12.39,7.91,24.09,16.49,25.48,22.05,2,8.11,11.86,18.11,16.59,22.91,1.21,1.23,2.25,2.29,2.48,2.64,1.32,2,10,6.91,11.69,7.88l.21.08c1.7.48,12.14,3.32,20.42,3.32,4.32,0,8.05-.77,9.65-3.06,2.56-3.64,10-9.5,16-14.2,4.24-3.34,7.91-6.22,9.25-7.83.37-.45,2.07-2,4.79-4.48l7.06,7.06-53.9,44.13h3l52.25-42.79,9.32,9.32-37.65,33.47h2.85l36.81-32.72a.94.94,0,0,0,0-1.38l-9.89-9.89,45.27-37.08,15.38,12.38-56.87,50.55a6.47,6.47,0,0,0,4.27,11.3,6.51,6.51,0,0,0,4.09-1.46l59.36-51.66.84.68v-3.92l-.89.77-7.87-6.33,8.76-7.79v-2.53l-10.25,9.11-15.32-12.33L445,237.4V235L417.9,257.12l-9.62-7.75c12.73-11.11,25.85-22.51,36.7-31.93v-2.51c-7.64,6.63-22.66,19.68-38.2,33.24l-19-15.29c16.73-16.48,39.23-38.79,42.79-43.14,6-7.34,8.37-28.72,2.62-38.94-3.47-6.17-12-8.88-20.46-9.9l32.24-31ZM434.79,273.14l7.85,6.32-59.08,51.42a4.56,4.56,0,0,1-5.89-7Zm-115.32-120c2-2.57,5.33-6.22,9.48-10.58a8.18,8.18,0,0,1,10.77-.92L379,170.7l-31.21,30L307.32,168.1C314.07,159.86,319.33,153.29,319.47,153.11ZM290,156.6l14.63,11.78c-5.54,6.75-11.59,14-16.64,19.87l-14-10.76C279.47,170.49,284.92,163.31,290,156.6Zm-37.78,4.08c5.6-7.57,13.48-17.73,16.3-21.36l20,16.09c-5.09,6.73-10.55,13.91-16,20.92Zm-8.62,52.51c7.57-7,18.34-20.18,29.26-34.21l13.89,10.71c-4.68,5.38-8.31,9.29-9.54,10-3.33,1.91-29.54,14.88-41.73,20.91C238.32,218.06,241.06,215.57,243.61,213.19Zm2.31,44.48c-6.19-3.91-12.54-7.66-18-10.89-2.15-1.27-4.15-2.45-5.93-3.52-2.41-1.45-4.88-3-7.34-4.59,4.81-4.08,10.17-8.68,15.46-13.32h0c1.78-.88,43.64-21.51,48-24,1.41-.81,5.32-5,10.21-10.62h.05a.93.93,0,0,0,.75-.37.92.92,0,0,0,.17-.76c5.22-6,11.38-13.45,16.78-20L346.4,202l-20.75,19.93,0,0-.05,0-32.24,39.68L264.39,238.9a1,1,0,0,0-1.29.11Zm85.29,57.2c-3.29,4.7-21.15.92-27.9-1-3.84-2.17-10.12-6-10.94-7.22a30.28,30.28,0,0,0-2.71-2.92c-4.61-4.68-14.2-14.43-16.1-22-1.53-6.13-13.26-14.86-26-23l16.36-17.76,29,22.81a1,1,0,0,0,1.32-.14L325.62,225l9.82,85.33A31.54,31.54,0,0,0,331.21,314.87Zm30.87-27.36c-3.13,2.82-5.13,4.68-5.57,5.2-1.21,1.45-5,4.42-9,7.55-3.5,2.76-7.25,5.72-10.38,8.46L327.3,223l20.58-19.77L384.94,233c-9.5,9.36-16.8,16.49-17,16.68a1,1,0,0,0-.27.54Zm44.75-36.87,9.57,7.71-45.11,36.94-7.12-7.12C372.82,280.39,389.36,265.89,406.83,250.64Zm-1.5-1.21c-15.75,13.75-31.81,27.83-41,36.09l5.2-34.68c1.49-1.46,8.33-8.15,16.94-16.62Zm-19-17.75-37-29.81,31.27-30,37.8,28C409.39,208.88,396.71,221.44,386.3,231.68Zm45.25-80c5.33,9.5,3.1,30.05-2.44,36.82-1.2,1.47-4.69,5.12-9.44,9.94l-37.76-28L411,142.59C419.78,143.48,428.39,146.11,431.55,151.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.15,
    y: 310.3,
    width: 150.61,
    height: 25.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.3,
    y: 322.7,
    width: 9.91,
    height: 11.33,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.99,
    y: 322.46,
    width: 9.91,
    height: 11.57,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.68,
    y: 319.87,
    width: 9.91,
    height: 14.16,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.37,
    y: 326.48,
    width: 9.91,
    height: 7.55,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.06,
    y: 318.92,
    width: 9.91,
    height: 15.11,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.76,
    y: 323.41,
    width: 9.91,
    height: 10.62,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.45,
    y: 328.36,
    width: 9.91,
    height: 5.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.14,
    y: 325.53,
    width: 9.92,
    height: 8.5,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.83,
    y: 327.89,
    width: 9.91,
    height: 6.14,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.53,
    y: 318.92,
    width: 9.91,
    height: 15.11,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.54,340.63h67c-4.59-2.2-11.49-5.66-12.33-6.91-1.26-1.89-8.2-13.89-12-14.52s-5.05,3.79-5.05,3.79l8.2,13.26-3.15-1.9s-7.58-8.21-9.47-9.47,0-6.31.63-10.1,5-6.31,6.31-9.47,0-12.63,0-15.78-5.68-12.63-9.47-20.21-16.41-22.09-23.36-25.25a27,27,0,0,0-7.34-1.87Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.14 153.15 325.04 165.78 337.67 182.2 361.03 170.2 335.14 153.15",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.77 209.98 333.25 223.87 338.93 254.8 354.71 259.22 359.77 245.96 374.92 231.44 347.77 209.98",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9,78h260A4.09,4.09,0,0,1,445,82.09V340.63a0,0,0,0,1,0,0H176.81a0,0,0,0,1,0,0V82.09A4.09,4.09,0,0,1,180.9,78Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9,78h260A4.09,4.09,0,0,1,445,82.09V128.5a0,0,0,0,1,0,0H176.81a0,0,0,0,1,0,0V82.09A4.09,4.09,0,0,1,180.9,78Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.35,
    y: 109.59,
    width: 211.5,
    height: 8.84,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.1,78H194.18v22.74H445V81.87A3.88,3.88,0,0,0,441.1,78Z",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9,78h260A4.09,4.09,0,0,1,445,82.09v10.7a0,0,0,0,1,0,0H176.81a0,0,0,0,1,0,0V82.09A4.09,4.09,0,0,1,180.9,78Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 433.96,
    cy: 85.65,
    r: 2.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.62,
    cy: 85.65,
    r: 2.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.28,
    cy: 85.65,
    r: 2.02,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Locations--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.9,168H341.6a4.72,4.72,0,0,0-4.73,4.72V204a4.72,4.72,0,0,0,4.73,4.72h9.85L358.69,223l6.65-14.25h9.56a4.72,4.72,0,0,0,4.72-4.72V172.72A4.72,4.72,0,0,0,374.9,168Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,183.19l1.15-7.65h2.36v10.78h-1.6v-7.73l-1.17,7.73h-1.6l-1.27-7.62v7.62h-1.47V175.54h2.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.56,178.13a2.57,2.57,0,1,1,5.14,0v5.6a2.57,2.57,0,1,1-5.14,0Zm1.69,5.71c0,.77.34,1.06.88,1.06s.87-.29.87-1.06V178c0-.77-.34-1.06-.87-1.06s-.88.29-.88,1.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.3,178.51v7.81h-1.52V175.54h2.12l1.74,6.45v-6.45h1.51v10.78h-1.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.24,191.72c-.54,0-.87.29-.87,1.06v1.15h-1.61v-1c0-1.73.87-2.71,2.53-2.71s2.52,1,2.52,2.71c0,3.38-3.37,4.65-3.37,6.42a.93.93,0,0,0,0,.23h3.2v1.54h-4.9v-1.33c0-3.17,3.36-3.69,3.36-6.8C356.12,192,355.78,191.72,355.24,191.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.34,191.72c-.54,0-.88.29-.88,1.06v1.15h-1.6v-1c0-1.73.87-2.71,2.53-2.71s2.52,1,2.52,2.71c0,3.38-3.37,4.65-3.37,6.42a.93.93,0,0,0,0,.23h3.2v1.54h-4.9v-1.33c0-3.17,3.36-3.69,3.36-6.8C362.22,192,361.88,191.72,361.34,191.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.25,
    cy: 229.85,
    r: 3.69,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.37,
    cy: 137.51,
    r: 3.69,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.69,228.62a3.69,3.69,0,1,1-3.69-3.7A3.69,3.69,0,0,1,296.69,228.62Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.61,
    cy: 200.81,
    r: 3.69,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.92,293.69a3.7,3.7,0,1,1-3.7-3.7A3.7,3.7,0,0,1,229.92,293.69Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.99,
    cy: 287.58,
    r: 3.69,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.9,
    cy: 173.92,
    r: 3.69,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.11,
    cy: 138.13,
    r: 3.69,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.18,233.78a3.7,3.7,0,1,1-3.69-3.7A3.69,3.69,0,0,1,410.18,233.78Z",
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.39,
    cy: 195.38,
    r: 3.69,
    style: {
      fill: "#407BFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.7d8e0f172c133ac3adf0e3f9be030624.svg";
export { ForwardRef as ReactComponent };